module.exports = __webpack_public_path__ + "static/img/2d.bfae95f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/art/2d.jpg
// module id = 5UDG
// module chunks = 0